// IMPORT REACT
import React from 'react';
import Axios from 'axios';

// IMPORT COMPONENTS
import YAText from '../../Text';
import YARow from '../../Grid/Row';
import YAColumn from '../../Grid/Column';
import YAButton from '../../Form/Button';
import YASubmit from '../../Form/Submit';
import YAIcon from '../../Icon';
import YAInput from '../../Form/Input';
import YAAlert from '../../Alert';
import YAProgress from '../../Progress';

// IMPORT STYLES
import { SC_Folder, SC_IconContainer } from '../styles';


class YAResourceAdd extends React.Component {

	constructor(props) {
		super();
		this.state = {
			formError: null,
			formSuccess: null,
			allCategories: [],
			uploading: false
		};
	}

	componentDidMount() {

		this.getCategories('en').then(data => {
			this.setState({
				allCategories: data,
			});
		});

	}

	addNewFile(e) {
		e.preventDefault();
		let url = '/wp-json/wp/v2/weemarkable/file-manage/';
		let form = document.getElementById("add_file_form");
		let data = new FormData(form);
		return Axios({
			method: 'post',
			url: url,
			data: data,
			headers: {
				// eslint-disable-next-line no-undef
				'X-WP-Nonce': frontend_ajax_object.nonce
			}
		}).then((response) => {
			return response.data;
		}).catch(function (error) {
			console.log(error, 'Error');
		});
	}

	getCategories(lang) {
		let url = '/wp-json/wp/v2/weemarkable/categories/';
		url += '?lang=';
		url += lang;
		url += '&parent=any';
		return Axios({
			method: 'get',
			url: url,
			headers: {
				// eslint-disable-next-line no-undef
				'X-WP-Nonce': frontend_ajax_object.nonce
			},
		}).then((response) => {
			return response.data;
		}).catch(function (error) {
			console.log(error, 'Error');
		});
	}

	render() {
		let formError = this.state.formError;
		let allCategories = this.state.allCategories;
		let cancelCallbackFunction = this.props.cancelCallbackFunction;
		let selectedCategory = this.props.selectedCategory;
		let uploading = this.state.uploading;

		let categoriesOptions = allCategories && allCategories.length ? allCategories.map((category) => {
			return ({
				id: category.slug,
				label: category.ancestors + ' ' + category.name_english,
				value: category.term_id,
			});
		}) : null;

		return (
			<SC_Folder>
				<YARow center="vertical">
					<YAColumn size="col-auto" autoWidth>
						<SC_IconContainer>
							<YAIcon icon="file" height="100px" fill="gray200" altFill="gray400" />
						</SC_IconContainer>
					</YAColumn>
					<YAColumn autoWidth>
						<YAText bootstrap="font-weight-bold text-left text-primary">
							Add New File
						</YAText>
					</YAColumn>
					<YAColumn size="col-auto" autoWidth>
						<YAButton size="sm" color="dark" onClick={() => { cancelCallbackFunction() }}>
							Cancel
						</YAButton>
					</YAColumn>
				</YARow>

				<form id="add_file_form" onSubmit={(e) => {
					this.setState({
						uploading: true
					});
					this.addNewFile(e).then(data => {
						if (data) {
							if (data.error) {
								this.setState({
									formSuccess: null,
									formError: data.error
								})
							} else if (data.success) {
								this.setState({
									formError: null
								})
								cancelCallbackFunction(data.success)
							}
						} else {
							this.setState({
								formSuccess: null,
								formError: 'Error'
							})
						}
						this.setState({
							uploading: false
						});
					});
				}}>
					{formError &&
						<YAAlert color="danger">
							{formError}
						</YAAlert>}
					{uploading &&
						<YAProgress />
					}
					
					<YAInput type="file" id="add_file" label="Upload File" />
					<YAInput type="select" id="add_parent" label="Parent Folder" value={selectedCategory} options={categoriesOptions} />

					<YASubmit color="success" value="Save" id="submit_button" disabled={uploading} />

					<br />	<br />
				</form>
			</SC_Folder>
		)
	}
}
export default YAResourceAdd;